import React, { useEffect, useState } from 'react';

const ParticipateFlyer = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <div
      className="google-landing-override ffw-typography"
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #eef4ff 0%, #dce8ff 46%, #edf4ff 100%)',
        width: '100%',
        margin: 0,
        padding: 0,
      }}
    >
      <header
        style={{
          padding: isMobile ? '12px 16px' : '16px 24px',
          borderBottom: '1px solid #e8eaed',
          backgroundColor: '#f8fbff',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            maxWidth: '1200px',
            margin: '0 auto',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '16px' : '0',
            width: '100%',
          }}
        >
          {!isMobile && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src="/assets/FFWLOGOtransparent.png"
                alt="Face Forward Web"
                style={{
                  height: '40px',
                  width: 'auto',
                  marginRight: '32px',
                }}
              />
            </div>
          )}

          <nav
            className="ffw-nav"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: isMobile ? '20px' : '32px',
              flexWrap: 'wrap',
              justifyContent: isMobile ? 'center' : 'flex-end',
            }}
          >
            <a
              href="/"
              style={{
                fontSize: '14px',
                color: '#5f6368',
                textDecoration: 'none',
                padding: '8px 0',
                borderBottom: '2px solid transparent',
                fontWeight: '500',
              }}
            >
              Home
            </a>
            <a
              href="/team"
              style={{
                fontSize: '14px',
                color: '#5f6368',
                textDecoration: 'none',
                padding: '8px 0',
                borderBottom: '2px solid transparent',
                fontWeight: '500',
              }}
            >
              Team
            </a>
            <a
              href="/support"
              style={{
                fontSize: '14px',
                color: '#5f6368',
                textDecoration: 'none',
                padding: '8px 0',
                borderBottom: '2px solid transparent',
                fontWeight: '500',
              }}
            >
              Support
            </a>
            <a
              href="/participate-flyer"
              style={{
                fontSize: '14px',
                color: '#202124',
                textDecoration: 'none',
                padding: '8px 0',
                borderBottom: '2px solid #4285f4',
                fontWeight: '500',
              }}
            >
              Participate/Refer
            </a>
            <a
              href="/login"
              style={{
                fontSize: '14px',
                color: '#4285f4',
                textDecoration: 'none',
                padding: '8px 16px',
                border: '1px solid #4285f4',
                borderRadius: '50px',
                fontWeight: '500',
              }}
            >
              Sign In
            </a>
          </nav>
        </div>
      </header>

      <main style={{ padding: isMobile ? '52px 16px 56px' : '84px 24px 88px' }}>
        <div
          style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}
        >
          <div
            style={{
              padding: isMobile ? '10px 6px' : '12px 8px',
              marginBottom: isMobile ? '24px' : '30px',
            }}
          >
            <h1
              style={{
                fontSize: isMobile ? '32px' : '56px',
                margin: '0 0 14px 0',
                color: '#202124',
                fontWeight: 600,
                lineHeight: 1.05,
              }}
            >
              Participate in Face Forward Web
            </h1>
            <p
              style={{
                color: '#5f6368',
                fontSize: isMobile ? '15px' : '18px',
                margin: '0 auto 22px',
                maxWidth: '720px',
              }}
            >
              Share the flyer below with people who may benefit from this
              evidence-based program.
            </p>

            <div
              style={{
                width: isMobile ? '90px' : '120px',
                height: '3px',
                background: 'linear-gradient(90deg, #355f98 0%, #5b86c2 100%)',
                borderRadius: '999px',
                margin: '0 auto 22px',
              }}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: isMobile ? '10px' : '14px',
                flexDirection: isMobile ? 'column' : 'row',
                marginBottom: '0',
              }}
            >
              <a
                href="/assets/participate-flyer.png"
                download
                style={{
                  backgroundColor: '#183457',
                  color: '#ffffff',
                  textDecoration: 'none',
                  borderRadius: '999px',
                  padding: '12px 22px',
                  fontWeight: 600,
                  fontSize: '14px',
                  boxShadow: '0 6px 16px rgba(24, 52, 87, 0.22)',
                }}
              >
                Download Flyer
              </a>
              <a
                href="/support"
                style={{
                  color: '#355f98',
                  textDecoration: 'none',
                  fontWeight: 600,
                  fontSize: '14px',
                }}
              >
                Need help sharing it?
              </a>
            </div>
          </div>

          <div className="ffw-panel" style={{ padding: isMobile ? '12px' : '16px' }}>
            <img
              src="/assets/participate-flyer.png"
              alt="Face Forward Web participation flyer"
              style={{
                width: '100%',
                maxWidth: '760px',
                height: 'auto',
                borderRadius: '10px',
                display: 'block',
                margin: '0 auto',
              }}
            />
          </div>
        </div>
      </main>

      <footer
        style={{
          borderTop: 'none',
          padding: isMobile ? '24px 16px' : '30px 24px',
          backgroundColor: 'transparent',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontSize: isMobile ? '11px' : '12px', color: '#6b7280', margin: 0 }}>
            © 2025 Face Forward Web. Developed by Harvard Medical School and Massachusetts General Hospital.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ParticipateFlyer;
